import { Text as ChakraText, Highlight } from '@chakra-ui/react';
import { Tooltip } from '@components/Overlay/Tooltip';
import { forwardRef } from 'react';

import { TextDefaultProps, type TextProps } from './Text.types';

// TODO: Replace highlight prop with query + highlightVariant
const Text = forwardRef<HTMLParagraphElement | HTMLDivElement, TextProps>(
  ({ children, as = 'div', highlight, tooltip, tooltipDisabled, ...props }, ref) => {
    const text = (
      <ChakraText ref={ref} as={as} {...props}>
        {highlight ? <Highlight {...highlight}>{`${children}`}</Highlight> : children}
      </ChakraText>
    );

    return (
      <>
        {tooltip ? (
          <Tooltip trigger={text} disabled={tooltipDisabled}>
            {tooltip}
          </Tooltip>
        ) : (
          text
        )}
      </>
    );
  }
);

Text.displayName = 'Text';
Text.defaultProps = TextDefaultProps;

export { Text };
